import script from "./SellerProductsList.vue?vue&type=script&setup=true&lang=js"
export * from "./SellerProductsList.vue?vue&type=script&setup=true&lang=js"

import "./SellerProductsList.vue?vue&type=style&index=0&id=2d5cf740&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d5cf740"]])

export default __exports__